export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="8" fill="currentColor" />
    <path
      d="M7.33848 4.66661C7.33848 4.29842 7.63696 3.99995 8.00515 3.99995C8.34704 3.99995 8.62882 4.25731 8.66733 4.58887L8.67181 4.66661L8.66731 11.3333C8.66731 11.7015 8.36883 12 8.00064 12C7.65875 12 7.37697 11.7426 7.33846 11.4111L7.33397 11.3333L7.33848 4.66661Z"
      fill="white"
    />
    <path
      d="M4.66661 8.66225C4.29842 8.66225 3.99995 8.36378 3.99995 7.99559C3.99995 7.6537 4.25731 7.37192 4.58887 7.33341L4.66661 7.32892L11.3333 7.33342C11.7015 7.33342 12 7.6319 12 8.00009C12 8.34198 11.7426 8.62376 11.4111 8.66227L11.3333 8.66676L4.66661 8.66225Z"
      fill="white"
    />
  </svg>
);
